import {SecureService} from "@/services/superclasses/secure-service";
import {Schedule} from "@/interfaces/schedule";

const api = window.contextPath + '/rest/schedules';

export class ScheduleSecureService extends SecureService {

    public loadAll = async (): Promise<Schedule[]> => {
        return this.data(await this.get<Schedule[]>(api))
    }
}

export const scheduleSecureService = new ScheduleSecureService()